import React, { Fragment, useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import useRequests from "../../../utils/useRequests";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../../utils/Snackbars";
import { checkImageValidation } from "../../../utils/Common";
import Select from "react-select";
import JoditEditor from "jodit-react";

const EditEvent = () => {
    const { e_id } = useParams();
    const navigate = useNavigate();
    const { getRequest, postRequestByFormData } = useRequests();
    const [start_datetime, setStartDateTime] = useState("");
    const [end_datetime, setEndDateTime] = useState("");
    const [organizers, setOrganizers] = useState([]);
    const [selectedOrganizer, setSelectedOrganizer] = useState("");
    const [loading, setLoading] = useState(true);
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");

    // Add event duration state
    const [eventDuration, setEventDuration] = useState(1); // Number of days for the event
    const [maxEventDays, setMaxEventDays] = useState(1); // Maximum days based on start/end date

    // Seats requirement states
    const [isSeatsRequired, setIsSeatsRequired] = useState("No");
    const [venues, setVenues] = useState([]);
    const [selectedVenue, setSelectedVenue] = useState(null);
    const [seatCategories, setSeatCategories] = useState([]);

    const [isTenDayChecked, setIsTenDayChecked] = useState(false);
    const handleTenDayCheckboxChange = (event) => {
        setIsTenDayChecked(event.target.checked);
    };

    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const [isCheckedTcs, setIsCheckedTcs] = useState(false);
    const handleCheckTcsChange = (event) => {
    setIsCheckedTcs(event.target.checked);
    };

    const [isCheckedGst, setIsCheckedGst] = useState(false);
    const handleCheckGstChange = (event) => {
    setIsCheckedGst(event.target.checked);
    };

    const calculateMaxEventDays = (startDate, endDate) => {
        if (!startDate || !endDate) return 1;
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
        
        return diffDays;
    };

    // Initialize tickets based on event duration
    const initializeTickets = (numDays) => {
        return Array.from({ length: numDays }, (_, dayIndex) => ({
        day: dayIndex + 1,
        tickets: [
            {
            id: Date.now() + dayIndex,
            type: "",
            time: "",
            category_id: "",
            total_tickets: "",
            price: "",
            resell_min_price: "",
            resell_max_price: "",
            status: "active",
            assigned_tickets: "",
            }
        ]
        }));
    };

    const [tickets, setTickets] = useState(() => initializeTickets(1));

    // Handle event duration change
    const handleEventDurationChange = (e) => {
        const newDuration = parseInt(e.target.value);
        const previousDuration = eventDuration;
        setEventDuration(newDuration);
        
        if (newDuration > previousDuration) {
            // Adding more days - preserve existing tickets and add new empty days
            const updatedTickets = [...tickets];
            
            // Add new days with empty ticket structure
            for (let i = previousDuration; i < newDuration; i++) {
                updatedTickets.push({
                    day: i + 1,
                    tickets: [
                        {
                            id: Date.now() + i,
                            type: "",
                            time: "",
                            category_id: "",
                            total_tickets: "",
                            price: "",
                            resell_min_price: "",
                            resell_max_price: "",
                            status: "active",
                            assigned_tickets: "",
                        }
                    ]
                });
            }
            
            setTickets(updatedTickets);
            validation1.setFieldValue("tickets", updatedTickets);
        } else if (newDuration < previousDuration) {
            // Reducing days - remove excess days from the end
            const updatedTickets = tickets.slice(0, newDuration);
            setTickets(updatedTickets);
            validation1.setFieldValue("tickets", updatedTickets);
        }
    };

    // Function to add a new ticket row for a specific day
    const addTicketRow = (dayIndex, e) => {
        e.preventDefault();

        const updatedTickets = [...tickets];
        updatedTickets[dayIndex].tickets.push({
            id: Date.now() + dayIndex,
            type: "",
            time: "",
            category_id: "",
            total_tickets: "",
            price: "",
            resell_min_price: "",
            resell_max_price: "",
            status: "active",
            assigned_tickets: ""
        });
        
        setTickets(updatedTickets);
        validation1.setFieldValue("tickets", updatedTickets);
    };

    // Function to delete a ticket row for a specific day (except the first one)
    const deleteTicketRow = (dayIndex, ticketId) => {
        const updatedTickets = [...tickets];
        if (updatedTickets[dayIndex].tickets.length > 1) {
            updatedTickets[dayIndex].tickets = updatedTickets[dayIndex].tickets.filter(
                (ticket) => ticket.id !== ticketId
            );
            setTickets(updatedTickets);
            validation1.setFieldValue("tickets", updatedTickets);
        }
    };

    // Function to update ticket values for a specific day
    const handleTicketChange = (dayIndex, ticketIndex, field, value) => {
        const updatedTickets = [...tickets];
        
        if (field === "category_id" && value) {
            // Auto-fill ticket type when category is selected
            const selectedCategory = seatCategories.find(cat => cat.value === value);
            if (selectedCategory) {
                updatedTickets[dayIndex].tickets[ticketIndex]["type"] = selectedCategory.label;
            }
        }
        
        updatedTickets[dayIndex].tickets[ticketIndex][field] = value;
        setTickets(updatedTickets);
        validation1.setFieldValue("tickets", updatedTickets);
    };

    const [tenDayTickets, setTenDayTickets] = useState([
        {
            id: Date.now() + "10",
            type: "",
            time: "",
            category_id: "",
            total_tickets: "",
            price: "",
            resell_min_price: "",
            resell_max_price: "",
            status: "active",
            assigned_tickets: ""
        },
    ]);

    const addTenDayTicketRow = (e) => {
        e.preventDefault();

        setTenDayTickets([
            ...tenDayTickets,
            {
                id: Date.now() + "10",
                type: "",
                time: "",
                category_id: "",
                total_tickets: "",
                price: "",
                resell_min_price: "",
                resell_max_price: "",
                status: "active",
                assigned_tickets: ""
            },
        ]);
    };

    const deleteTenDayTicketRow = (id) => {
        if (tenDayTickets.length > 1) {
            setTenDayTickets(tenDayTickets.filter((ticket) => ticket.id !== id));
        }
    };

    // Function to update ten day ticket values
    const handleTenDayTicketChange = (index, field, value) => {
        const updatedTickets = [...tenDayTickets];
        
        if (field === "category_id" && value) {
            // Auto-fill ticket type when category is selected
            const selectedCategory = seatCategories.find(cat => cat.value === value);
            if (selectedCategory) {
                updatedTickets[index]["type"] = selectedCategory.label;
            }
        }
        
        updatedTickets[index][field] = value;
        setTenDayTickets(updatedTickets);
        validation1.setFieldValue("tenDayTickets", updatedTickets);
    };

    const [formData, setFormData] = useState({
        o_id: "",
        admin_event: "",
        name: "",
        city: "",
        address: "",
        location: "",
        start_datetime: "",
        end_datetime: "",
        startTime: "",
        endTime: "",
        short_description: "",
        description: "",
        banner: "",
        is_seats_required: "No",
        v_id: "",
        tickets: tickets,
        tenDayTickets: tenDayTickets,
    });

    const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
    });

    const resetAlertData = () => {
        setTimeout(() => {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
            }));
        }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
    };

    // Fetch venues function
    const fetchVenues = async () => {
        try {
            const response = await getRequest("venue-dropdown");
            if (response && response.code === 200) {
                const venueOptions = response.data
                    .map(venue => ({
                        value: venue.v_id,
                        label: `${venue.name} - ${venue.city}`,
                        name: venue.name,
                        city: venue.city
                    }));
                setVenues(venueOptions);
            }
        } catch (error) {
            console.error("Failed to fetch venues:", error);
        }
    };

    // Fetch seat categories based on selected venue
    const fetchSeatCategories = async (venueId) => {
        try {
            const response = await getRequest(`seat-category-dropdown/${venueId}`);
            if (response && response.code === 200) {
                const categoryOptions = response.data
                    .map(category => ({
                        value: category.sc_id,
                        label: category.category_name,
                        code: category.category_code,
                        total_seats: category.total_seats
                    }));
                setSeatCategories(categoryOptions);
            }
        } catch (error) {
            console.error("Failed to fetch seat categories:", error);
        }
    };

    // Handle seats requirement change
    const handleSeatsRequiredChange = (event) => {
        const value = event.target.value;
        setIsSeatsRequired(value);
        validation1.setFieldValue("is_seats_required", value);

        if (value === "No") {
            setSelectedVenue(null);
            setSeatCategories([]);
            validation1.setFieldValue("v_id", "");

            // Reset category_id for all tickets in day-based structure
            const resetTickets = tickets.map(dayData => ({
                ...dayData,
                tickets: dayData.tickets.map(ticket => ({
                    ...ticket,
                    category_id: "",
                    type: ""
                }))
            }));
            
            const updatedTenDayTickets = tenDayTickets.map(ticket => ({ ...ticket, category_id: "", type: "" }));
            setTickets(resetTickets);
            setTenDayTickets(updatedTenDayTickets);
            validation1.setFieldValue("tickets", resetTickets);
            validation1.setFieldValue("tenDayTickets", updatedTenDayTickets);
        }
    };

    // Handle venue selection
    const handleVenueChange = (selectedOption) => {
        setSelectedVenue(selectedOption);
        validation1.setFieldValue("v_id", selectedOption ? selectedOption.value : "");

        if (selectedOption) {
            fetchSeatCategories(selectedOption.value);
        } else {
            setSeatCategories([]);
            // Reset category_id for all tickets in day-based structure
            const resetTickets = tickets.map(dayData => ({
                ...dayData,
                tickets: dayData.tickets.map(ticket => ({
                    ...ticket,
                    category_id: "",
                    type: ""
                }))
            }));
            
            const updatedTenDayTickets = tenDayTickets.map(ticket => ({ ...ticket, category_id: "", type: "" }));
            setTickets(resetTickets);
            setTenDayTickets(updatedTenDayTickets);
            validation1.setFieldValue("tickets", resetTickets);
            validation1.setFieldValue("tenDayTickets", updatedTenDayTickets);
        }
    };

    const formatDateTimeForInput = (isoString) => {
        const date = new Date(isoString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const fetchEventDetails = async () => {
        const response = await getRequest(`event-details/${e_id}`);
        if (response && response.code === 200) {
            const data = response.data;
            
            // Calculate max days and actual event duration from dates
            const formattedStartDateTime = formatDateTimeForInput(data.start_datetime);
            const formattedEndDateTime = formatDateTimeForInput(data.end_datetime);
            
            // Calculate max event days based on start/end dates
            const calculatedMaxDays = calculateMaxEventDays(formattedStartDateTime, formattedEndDateTime);
            setMaxEventDays(calculatedMaxDays);
            
            // Determine actual event duration from the ticket data
            let actualEventDuration = 1;
            if (data.eventTicketTypeData && data.eventTicketTypeData.length > 0) {
                // Find the highest day number from existing tickets
                const dayNumbers = data.eventTicketTypeData
                    .filter(ticket => ticket.day_pass !== "10" && ticket.day_number)
                    .map(ticket => parseInt(ticket.day_number));
                
                if (dayNumbers.length > 0) {
                    actualEventDuration = Math.max(...dayNumbers);
                }
            }
            
            // Ensure duration doesn't exceed max days
            actualEventDuration = Math.min(actualEventDuration, calculatedMaxDays);
            setEventDuration(actualEventDuration);

            // Initialize day-based tickets structure with correct number of days
            const dayTicketsStructure = Array.from({ length: actualEventDuration }, (_, dayIndex) => ({
                day: dayIndex + 1,
                tickets: []
            }));
            
            let tenDaysData = [];
            
            data.eventTicketTypeData.forEach(element => {
                if (element.day_pass === "10") {
                    let ticketData = {
                        id: element.e_t_id,
                        type: element.type,
                        time: element.time,
                        category_id: element.sc_id || "",
                        total_tickets: element.total_tickets,
                        price: element.price,
                        resell_min_price: element.resell_min,
                        resell_max_price: element.resell_max,
                        status: element.day_status || "active",
                        assigned_tickets: element.assigned_tickets
                    };
                    tenDaysData.push(ticketData);
                } else {
                    // For 1-day tickets, distribute them across days
                    let ticketData = {
                        id: element.e_t_id,
                        type: element.type,
                        time: element.time,
                        category_id: element.sc_id || "",
                        total_tickets: element.total_tickets,
                        price: element.price,
                        resell_min_price: element.resell_min,
                        resell_max_price: element.resell_max,
                        status: element.day_status || "active",
                        assigned_tickets: element.assigned_tickets
                    };
                    
                    // If backend provides day_number, use it; otherwise distribute to first day
                    const dayNumber = element.day_number || 1;
                    const dayIndex = dayNumber - 1;
                    
                    if (dayIndex >= 0 && dayIndex < actualEventDuration) {
                        dayTicketsStructure[dayIndex].tickets.push(ticketData);
                    }
                }
            });

            // Ensure each day has at least one empty ticket if no tickets exist
            dayTicketsStructure.forEach((dayData, index) => {
                if (dayData.tickets.length === 0) {
                    dayData.tickets.push({
                        id: Date.now() + index,
                        type: "",
                        time: "",
                        category_id: "",
                        total_tickets: "",
                        price: "",
                        resell_min_price: "",
                        resell_max_price: "",
                        status: "active",
                        assigned_tickets: ""
                    });
                }
            });

            setTickets(dayTicketsStructure);
            setTenDayTickets(tenDaysData);
            // Normalize flag values: they can arrive as real booleans OR as the
            // strings "true"/"false". A plain truthiness check would treat the
            // string "false" as true, which caused unchecked GST/TCS to re-check
            // themselves after update. Compare explicitly instead.
            const toFlag = (v) => v === true || v === "true" || v === 1 || v === "1";
            setIsChecked(toFlag(data.one_day_ticket));
            setIsTenDayChecked(toFlag(data.ten_day_ticket));
            setIsCheckedGst(toFlag(data.gst));
            setIsCheckedTcs(toFlag(data.tcs));

            // Set seats requirement
            const seatsRequired = data.is_seats_required || "No";
            setIsSeatsRequired(seatsRequired);

            let startTimeObj = {
                value: data.start_time,
                label: data.start_time,
            };
            setStartTime(startTimeObj);

            let endTimeObj = {
                value: data.end_time,
                label: data.end_time,
            };
            setEndTime(endTimeObj);

            setSelectedOrganizer(data.o_id);
            setStartDateTime(formattedStartDateTime);
            setEndDateTime(formattedEndDateTime);

            setFormData({
                o_id: data.o_id,
                admin_event: data.admin_event,
                name: data.name,
                city: data.city,
                address: data.address,
                location: data.location,
                start_datetime: formattedStartDateTime,
                end_datetime: formattedEndDateTime,
                startTime: startTimeObj,
                endTime: endTimeObj,
                short_description: data.short_description,
                description: data.description,
                is_seats_required: seatsRequired,
                v_id: data.v_id || "",
                banner: data.logo,
            });

            // Return data for venue/category setup
            return data;
        } else {
            setAlertData({ variant: "error", message: response.message || "Failed to fetch event details" });
            return null;
        }
    };

    const fetchOrganizers = async () => {
        const response = await getRequest("o-list");
        if (response && response.code === 200) {
            let organizerData = [];
            response.data.forEach(element => {
                if (element.status == "Enable") {
                    organizerData.push(element);
                }
            });
            setOrganizers(organizerData);
        } else {
            console.error("Failed to fetch organizers:", response.message);
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: 'Failed to fetch organizers',
            }));
        }
        resetAlertData();
    };

    const [File, setFile] = useState();
    const [FileName, setFileName] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            // First fetch venues and organizers
            await Promise.all([
                fetchOrganizers(),
                fetchVenues()
            ]);
            
            // Then fetch event details
           await fetchEventDetails();
            
            // Set loading to false
            setLoading(false);
        };
        fetchData();
    }, []);

    // Add another useEffect to handle venue selection after venues are loaded
    useEffect(() => {
        const setVenueFromEventData = async () => {
            if (venues.length > 0 && formData.v_id && isSeatsRequired === "Yes" && !selectedVenue) {
                const venueOption = venues.find(venue => venue.value === formData.v_id);
                if (venueOption) {
                    setSelectedVenue(venueOption);
                    await fetchSeatCategories(formData.v_id);
                }
            }
        };
        
        setVenueFromEventData();
    }, [venues, formData.v_id, isSeatsRequired]);

    useEffect(() => {
      // Update tickets when seat categories are loaded and tickets have category_id values
      if (seatCategories.length > 0 && isSeatsRequired === "Yes") {
          // Update 1-day tickets in day-based structure
          const updatedTickets = tickets.map(dayData => ({
              ...dayData,
              tickets: dayData.tickets.map(ticket => {
                  if (ticket.category_id && ticket.category_id !== "") {
                      const selectedCategory = seatCategories.find(cat => cat.value === ticket.category_id);
                      if (selectedCategory && ticket.type !== selectedCategory.label) {
                          return {
                              ...ticket,
                              type: selectedCategory.label
                          };
                      }
                  }
                  return ticket;
              })
          }));
          
          // Update 10-day tickets
          const updatedTenDayTickets = tenDayTickets.map(ticket => {
              if (ticket.category_id && ticket.category_id !== "") {
                  const selectedCategory = seatCategories.find(cat => cat.value === ticket.category_id);
                  if (selectedCategory && ticket.type !== selectedCategory.label) {
                      return {
                          ...ticket,
                          type: selectedCategory.label
                      };
                  }
              }
              return ticket;
          });
          
          // Only update if there are changes
          if (JSON.stringify(updatedTickets) !== JSON.stringify(tickets)) {
              setTickets(updatedTickets);
          }
          if (JSON.stringify(updatedTenDayTickets) !== JSON.stringify(tenDayTickets)) {
              setTenDayTickets(updatedTenDayTickets);
          }
      }
  }, [seatCategories, isSeatsRequired]);

    const saveFile = (e) => {
        if ((e.target.files).length > 0) {
            setFile(e.target.files[0]);
            setFileName(e.target.files[0].name);
            var validationRes = checkImageValidation(e.target.files[0]);
            if (!validationRes.status) {
                setFile();
                setFileName('');
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: validationRes.msg,
                }));
                resetAlertData();
                return false;
            }
        }
    };

    const handleStartChange = (e) => {
        const newStartDate = e.target.value;
        validation1.setFieldValue('start_datetime', newStartDate);
        setStartDateTime(newStartDate);
        validation1.handleChange(e);
        
        if (newStartDate && validation1.values.end_datetime) {
            const maxDays = calculateMaxEventDays(newStartDate, validation1.values.end_datetime);
            setMaxEventDays(maxDays);
            
            // Check if new start date is BEFORE current start date (extending range)
            const currentStartDate = new Date(start_datetime);
            const selectedStartDate = new Date(newStartDate);
            const isExtendingStart = selectedStartDate < currentStartDate;
            
            // If current duration exceeds max days OR start date moved forward (after current)
            if (eventDuration > maxDays || !isExtendingStart) {
                // Only reset if reducing days or moving start date forward
                if (eventDuration > maxDays) {
                    setEventDuration(maxDays);
                    const newTickets = initializeTickets(maxDays);
                    setTickets(newTickets);
                    validation1.setFieldValue("tickets", newTickets);
                }
            }
            // If extending the range (start date moved backward), keep current duration
            // User can manually change duration to add more days if needed
        }
    };

    const handleEndChange = (e) => {
        const newEndDate = e.target.value;
        validation1.setFieldValue('end_datetime', newEndDate);
        setEndDateTime(newEndDate);
        validation1.handleChange(e);
        
        if (validation1.values.start_datetime && newEndDate) {
            const maxDays = calculateMaxEventDays(validation1.values.start_datetime, newEndDate);
            setMaxEventDays(maxDays);
            
            // Check if new end date is AFTER current end date (extending range)
            const currentEndDate = new Date(end_datetime);
            const selectedEndDate = new Date(newEndDate);
            const isExtendingEnd = selectedEndDate > currentEndDate;
            
            // If current duration exceeds max days OR end date moved backward (before current)
            if (eventDuration > maxDays || !isExtendingEnd) {
                // Only reset if reducing days or moving end date backward
                if (eventDuration > maxDays) {
                    setEventDuration(maxDays);
                    const newTickets = initializeTickets(maxDays);
                    setTickets(newTickets);
                    validation1.setFieldValue("tickets", newTickets);
                }
            }
            // If extending the range (end date moved forward), keep current duration
            // User can manually change duration to add more days if needed
        }
    };

    const generateTimeOptions = () => {
        const times = [];
        const periods = ["AM", "PM"];

        for (let i = 0; i < 12; i++) {
            for (let j = 0; j < 60; j += 15) {
                const hour = i === 0 ? 12 : i;
                const minute = j < 10 ? `0${j}` : j;
                periods.forEach((period) => {
                    times.push({
                        value: `${hour}:${minute} ${period}`,
                        label: `${hour}:${minute} ${period}`,
                    });
                });
            }
        }
        return times;
    };

    const timeOptions = generateTimeOptions();

    const handleSelectChange = (event) => {
        validation1.setFieldValue('o_id', event.target.value);
        setSelectedOrganizer(event.target.value);
    };

    // Form validation schema
    const validation1 = useFormik({
        enableReinitialize: true,
        initialValues: formData,
        validationSchema: Yup.object({
            o_id: Yup.string().required(' Organizer is required'),
            name: Yup.string().required('Event Name is required'),
            city: Yup.string().required('City is required'),
            address: Yup.string().required('Address is required'),
            location: Yup.string().required('Location Link is required'),
            start_datetime: Yup.string().required('Please select Start Date'),
            end_datetime: Yup.string()
                .required("Please select End Date & Time")
                .test(
                "is-after-start",
                "End date must be after start date",
                function(value) {
                    const { start_datetime } = this.parent;
                    if (!start_datetime || !value) return true;
                    return new Date(value) >= new Date(start_datetime);
                }
            ),
            startTime: Yup.mixed().test('is-valid', 'Please select Start Time', value => value && value.value),
            endTime: Yup.mixed().test('is-valid', 'Please select End Time', value => value && value.value),
            short_description: Yup.string().required('Short Description is required'),
            description: Yup.string().required('Description is required'),
            is_seats_required: Yup.string().required('Please select if seats are required'),
            v_id: Yup.string().when('is_seats_required', {
                is: 'Yes',
                then: Yup.string().required('Please select a venue'),
                otherwise: Yup.string()
            }),
            tickets: isChecked ? Yup.array().of(
                Yup.object({
                    day: Yup.number().required(),
                    tickets: Yup.array().of(
                        Yup.object({
                            type: Yup.string().required("Ticket Type is required"),
                            status: Yup.string().oneOf(['active', 'sold out', 'coming soon'], 'Invalid status'),
                            category_id: Yup.string().when("$is_seats_required", {
                                is: "Yes",
                                then: (schema) => schema.required("Please select a seat category"),
                                otherwise: (schema) => schema.notRequired()
                            }),
                            total_tickets: Yup.number()
                                .typeError('Total tickets must be a number')
                                .required('Total tickets is required')
                                .positive('Must be positive')
                                .integer('Must be an integer'),
                            price: Yup.number()
                                .required("Price is required")
                                .positive("Price must be greater than 0"),
                            resell_min_price: Yup.number()
                                .required("Resell Min Price is required")
                                .positive("Min Price must be greater than 0")
                                .test(
                                "is-less-than-price",
                                "Min resell price should be less than ticket price",
                                function(value) {
                                    const { price } = this.parent;
                                    return !value || !price || value <= price;
                                }
                            ),
                            resell_max_price: Yup.number()
                                .required("Resell Max Price is required")
                                .positive("Max Price must be greater than 0")
                                .test(
                                "is-greater-than-min",
                                "Max resell price must be greater than min resell price",
                                function(value) {
                                    const { resell_min_price } = this.parent;
                                    return !value || !resell_min_price || value >= resell_min_price;
                                }
                            ),
                        })
                    ).min(1, "At least one ticket type is required for each day")
                })
            ).min(1, `At least one day must be configured`) : Yup.array(),
            tenDayTickets: isTenDayChecked ? Yup.array().of(
                Yup.object({
                    type: Yup.string().required("Ticket Type is required"),
                    status: Yup.string().oneOf(['active', 'sold out', 'coming soon'], 'Invalid status'),
                    category_id: Yup.string().when("$is_seats_required", {
                        is: "Yes",
                        then: (schema) => schema.required("Please select a seat category"),
                        otherwise: (schema) => schema.notRequired()
                    }),
                    total_tickets: Yup.number()
                        .typeError('Total tickets must be a number')
                        .required('Total tickets is required')
                        .positive('Must be positive')
                        .integer('Must be an integer'),
                    price: Yup.number()
                        .required("Price is required")
                        .positive("Price must be greater than 0"),
                    resell_min_price: Yup.number()
                        .required("Resell Min Price is required")
                        .positive("Min Price must be greater than 0")
                        .test(
                        "is-less-than-price",
                        "Min resell price should be less than ticket price",
                        function(value) {
                            const { price } = this.parent;
                            return !value || !price || value <= price;
                        }
                    ),
                    resell_max_price: Yup.number()
                        .required("Resell Max Price is required")
                        .positive("Max Price must be greater than 0")
                        .test(
                        "is-greater-than-min",
                        "Max resell price must be greater than min resell price",
                        function(value) {
                            const { resell_min_price } = this.parent;
                            return !value || !resell_min_price || value >= resell_min_price;
                        }
                    ),
                })
            ).min(1, "At least one 10-day pass ticket type is required") : Yup.array(),
        }),
        onSubmit: async (values) => {
            try {
                let submit1 = document.getElementById('submit1');
                submit1.disabled = true;
                submit1.textContent = ('Processing...');

                const formData = new FormData();
                formData.append("o_id", values.o_id);
                formData.append("admin_event", values.admin_event);
                formData.append("name", values.name);
                formData.append("city", values.city);
                formData.append("banner", File || formData.banner);
                formData.append("address", values.address);
                formData.append("location", values.location);
                formData.append("start_datetime", start_datetime);
                formData.append("end_datetime", end_datetime);
                formData.append("start_time", startTime.value);
                formData.append("end_time", endTime.value);
                formData.append("short_description", values.short_description);
                formData.append("description", values.description);
                formData.append("is_seats_required", values.is_seats_required);
                formData.append("v_id", values.v_id || "");
                formData.append("one_day_ticket", isChecked);
                formData.append("ten_day_ticket", isTenDayChecked);
                formData.append("gst", isCheckedGst);
                formData.append("tcs", isCheckedTcs);
                
                // Calculate total tickets
                let totalTickets = 0;
                
                // Flatten 1 day tickets for backend processing
                const flattenedOneDayTickets = [];
                if (isChecked) {
                    tickets.forEach(dayData => {
                        dayData.tickets.forEach(ticket => {
                            flattenedOneDayTickets.push({
                                ...ticket,
                                day_number: dayData.day
                            });
                            totalTickets += parseInt(ticket.total_tickets) || 0;
                        });
                    });
                }
                
                if (isTenDayChecked) {
                    tenDayTickets.forEach(ticket => {
                        totalTickets += parseInt(ticket.total_tickets) || 0;
                    });
                }
                
                formData.append("total_tickets", totalTickets);
                formData.append("tickets", JSON.stringify(flattenedOneDayTickets));
                formData.append("tenDayTickets", JSON.stringify(tenDayTickets));

                const res = await postRequestByFormData(`event-edit/${e_id}`, formData);

                if (res && res.code === 200) {
                    navigate('/events-list', {
                        state: { variant: "success", message: "Event updated successfully!" }
                    });
                } else {
                    setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'error',
                        message: res.message || "Failed to update event.",
                    }));
                    resetAlertData();
                }

                submit1.disabled = false;
                submit1.textContent = ('Update Event');
            } catch (error) {
                console.error("Error: ", error);
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: "An error occurred while updating the event.",
                }));
                resetAlertData();
            }
        }
    });

    // Add this helper function near the top of the component, after the state declarations
    const getDateForDay = (dayNumber) => {
        if (!validation1.values.start_datetime) return '';
        
        const startDate = new Date(validation1.values.start_datetime);
        const targetDate = new Date(startDate);
        targetDate.setDate(startDate.getDate() + (dayNumber - 1));
        
        const day = String(targetDate.getDate()).padStart(2, '0');
        const month = String(targetDate.getMonth() + 1).padStart(2, '0');
        const year = targetDate.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    return (
        <Fragment>
            <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
                <h2 className="text-black font-w600 mb-0">Edit Event</h2>
            </div>

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="basic-form">
                            {AlertData.message !== "" ? (
                                <Snackbars
                                    variant={AlertData.variant}
                                    message={AlertData.message}
                                />
                            ) : (
                                ""
                            )}
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div className="row mb-3">

                                    <div className="form-group mb-3 col-md-4 col-xs-12">
                                        <label>Select Organizer :</label>
                                        <select
                                            name="o_id"
                                            className="form-control"
                                            value={selectedOrganizer}
                                            onChange={handleSelectChange}
                                            disabled={true}
                                        >
                                            <option value="">--select organizer--</option>
                                            {organizers.map((organizer) => (
                                                <option key={organizer.o_id} value={organizer.o_id}>
                                                    {organizer.first_name} {organizer.last_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group mb-3 col-md-8 col-xs-12">
                                        <label>Event :</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className={`form-control ${validation1.touched.name && validation1.errors.name ? 'is-invalid' : ''}`}
                                            placeholder="Please Enter Event "
                                            value={validation1.values.name || ''}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.name && validation1.touched.name && (
                                            <small className="text-danger">{validation1.errors.name}</small>
                                        )}
                                    </div>
                                    <div className="form-group mb-3 col-md-4 col-xs-12">
                                        <label>City :</label>
                                        <input placeholder="Please Enter City"
                                            name="city"
                                            className={`form-control ${validation1.touched.city && validation1.errors.city ? 'is-invalid' : ''}`}
                                            value={validation1.values.city}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.city && validation1.touched.city && (
                                            <small className="text-danger">{validation1.errors.city}</small>
                                        )}
                                    </div>
                                    <div className="form-group mb-3 col-md-8 col-xs-12">
                                        <label>Address :</label>
                                        <input type="text"
                                            placeholder="Please Enter Address"
                                            name="address"
                                            className={`form-control ${validation1.touched.address && validation1.errors.address ? 'is-invalid' : ''}`}
                                            value={validation1.values.address}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.address && validation1.touched.address && (
                                            <small className="text-danger">{validation1.errors.address}</small>
                                        )}
                                    </div>
                                    <div className="form-group mb-3 col-md-8 col-xs-12">
                                        <label>Location Link :</label>
                                        <input type="text" 
                                        placeholder="Please Enter Location Link" 
                                        name="location"
                                        className={`form-control ${validation1.touched.location && validation1.errors.location ? 'is-invalid' : ''}`}
                                        value={validation1.values.location}
                                        onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.location && validation1.touched.location && (
                                            <small className="text-danger">{validation1.errors.location}</small>
                                        )}
                                    </div>
                                    <div className="form-group mb-3 col-md-12">
                                        <label>Short Description :</label>
                                        <textarea
                                            rows={2}
                                            placeholder="Please Enter Event Description"
                                            name="short_description"
                                            className={` form-control ${validation1.touched.short_description && validation1.errors.short_description ? 'is-invalid' : ''}`}
                                            value={validation1.values.short_description}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.short_description && validation1.touched.short_description && (
                                            <small className="text-danger">{validation1.errors.short_description}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-2 col-md-3 col-sm-6">
                                        <label>Start Date :</label>
                                        <input
                                            type="date"
                                            placeholderText="Please Select Date"
                                            name="start_datetime"
                                            className={`form-control ${validation1.touched.start_datetime && validation1.errors.start_datetime ? 'is-invalid' : ''}`}
                                            value={start_datetime}
                                            onChange={handleStartChange}
                                            min={new Date().toISOString().split('T')[0]}
                                        />
                                        {validation1.errors.start_datetime && validation1.touched.start_datetime && (
                                            <small className="text-danger">{validation1.errors.start_datetime}</small>
                                        )}
                                    </div>
                                    <div className="form-group mb-3 col-md-3 col-sm-6">
                                        <label>End Date :</label>
                                        <input
                                            type="date"
                                            placeholderText="Please Select Date"
                                            name="end_datetime"
                                            className={`form-control ${validation1.touched.end_datetime && validation1.errors.end_datetime ? 'is-invalid' : ''}`}
                                            value={end_datetime}
                                            onChange={handleEndChange}
                                            min={validation1.values.start_datetime || new Date().toISOString().split("T")[0]}
                                        />
                                        {validation1.errors.end_datetime && validation1.touched.end_datetime && (
                                            <small className="text-danger">{validation1.errors.end_datetime}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-3 col-sm-6">
                                        <label>Start Time :</label>
                                        <Select
                                            className="form-control timepicket"
                                            options={timeOptions}
                                            value={startTime}
                                            onChange={(selectedOption) => {
                                                setStartTime(selectedOption);
                                                validation1.setFieldValue("startTime", selectedOption);
                                            }}
                                            placeholder="Select Time"
                                            isSearchable={false}
                                        />
                                        {validation1.errors.startTime && validation1.touched.startTime && (
                                            <small className="text-danger">{validation1.errors.startTime}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-3 col-sm-6">
                                        <label>End Time:</label>
                                        <Select
                                            className="form-control timepicket"
                                            options={timeOptions}
                                            value={endTime}
                                            onChange={(selectedOption) => {
                                                setEndTime(selectedOption);
                                                validation1.setFieldValue("endTime", selectedOption);
                                            }}
                                            placeholder="Select Time"
                                            isSearchable={false}
                                        />
                                        {validation1.errors.endTime && validation1.touched.endTime && (
                                            <small className="text-danger">{validation1.errors.endTime}</small>
                                        )}
                                    </div>

                                    {/* <div className="form-group mb-3 col-md-12">
                                        <label>Event Description :</label>
                                        <textarea
                                            placeholder="Please Enter Event Description"
                                            name="description"
                                            className={`form-control `}
                                            value={validation1.values.description}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.description && validation1.touched.description && (
                                            <small className="text-danger">{validation1.errors.description}</small>
                                        )}
                                    </div> */}
                                    <div className="form-group mb-3 col-md-12">
                                        <label>Event Description :</label>
                                        <JoditEditor
                                        value={validation1.values.description}
                                        onBlur={(newContent) =>
                                            validation1.setFieldValue("description", newContent)
                                        }
                                        onChange={(newContent) =>
                                            validation1.setFieldValue("description", newContent)
                                        }
                                        />
                                        {validation1.touched.description && validation1.errors.description ? (
                                        <div className="invalid-feedback d-block">
                                            {validation1.errors.description}
                                        </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-3 col-md-12 col-xs-12">
                                        <label>Event Banner :</label>
                                        <input
                                            type="file"
                                            className={`form-control ${validation1.touched.banner && validation1.errors.banner ? 'is-invalid' : ''}`}
                                            name="banner"
                                            onChange={saveFile}
                                        />
                                        {formData.banner && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                                                <img src={formData.banner} alt="Event banner" style={{ width: '100px', height: 'auto' }} />
                                                <p style={{ color: 'black', margin: 0 }}>Only PNG, JPEG, JPG files allowed.</p>
                                            </div>
                                        )}
                                    </div>

                                    {/* Seats Required Field */}
                                    <div className="form-group mb-3 col-md-4 col-xs-12">
                                        <label>Seats Required <span className="text-danger">*</span>:</label>
                                        <select
                                            name="is_seats_required"
                                            className={`form-control ${validation1.touched.is_seats_required && validation1.errors.is_seats_required ? 'is-invalid' : ''}`}
                                            value={isSeatsRequired}
                                            onChange={handleSeatsRequiredChange}
                                        >
                                            <option value="No">No</option>
                                            <option value="Yes">Yes</option>
                                        </select>
                                        {validation1.errors.is_seats_required && validation1.touched.is_seats_required && (
                                            <small className="text-danger">{validation1.errors.is_seats_required}</small>
                                        )}
                                    </div>

                                    {/* Venue Selection - Only show if seats are required */}
                                    {isSeatsRequired === "Yes" && (
                                        <div className="form-group mb-3 col-md-8 col-xs-12">
                                            <label>Select Venue <span className="text-danger">*</span>:</label>
                                            <Select
                                                options={venues}
                                                value={selectedVenue}
                                                onChange={handleVenueChange}
                                                placeholder="Search and select venue..."
                                                isClearable
                                                isSearchable
                                                className={validation1.touched.v_id && validation1.errors.v_id ? 'is-invalid' : ''}
                                            />
                                            {validation1.errors.v_id && validation1.touched.v_id && (
                                                <small className="text-danger">{validation1.errors.v_id}</small>
                                            )}
                                        </div>
                                    )}

                                    {/* Add event duration selector before ticket sections */}
                                    <div className="row mb-3">
                                    <div className="form-group mb-3 col-md-4">
                                        <label>Event Duration (Days):</label>
                                        <select
                                        className="form-control"
                                        value={eventDuration}
                                        onChange={handleEventDurationChange}
                                        disabled={!validation1.values.start_datetime || !validation1.values.end_datetime}
                                        >
                                        {Array.from({ length: maxEventDays }, (_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                            {i + 1} Day{i + 1 > 1 ? 's' : ''}
                                            </option>
                                        ))}
                                        </select>
                                        <small className="text-muted">
                                        {!validation1.values.start_datetime || !validation1.values.end_datetime 
                                            ? "Please select start and end dates first" 
                                            : `Total ${maxEventDays} day${maxEventDays > 1 ? 's' : ''} based on selected dates`
                                        }
                                        </small>
                                    </div>
                                    </div>

                                    <div className="events-types-box">
                                        <div className="row">
                                            <p className="title-pass-price">
                                                {eventDuration === 1 ? 'Single Day' : `${eventDuration} Day`} Pass Ticket Price
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={isChecked}
                                                    onChange={handleCheckboxChange}
                                                />
                                            </p>
                                        </div>

                                        {isChecked && tickets.map((dayData, dayIndex) => (
                                            <div key={dayData.day} className="day-tickets-section" style={{marginBottom: '30px', border: '1px solid #ddd', padding: '15px', borderRadius: '5px'}}>
                                                <div className="row" style={{marginBottom: '15px', alignItems: 'center'}}>
                                                    <div className="col-md-12">
                                                        <h5 className="day-title" style={{margin: '0', color: '#333', borderBottom: '2px solid #007bff', paddingBottom: '5px', display: 'inline-block'}}>
                                                            {eventDuration === 1 
                                                                ? `Event` 
                                                                : `Day ${dayData.day} (${getDateForDay(dayData.day)}) Tickets`
                                                            }
                                                        </h5>
                                                    </div>
                                                </div>
                                                
                                                {dayData.tickets.map((ticket, ticketIndex) => (
                                                    <div className="row cstm-price-box" key={ticket.id} style={{marginBottom: '10px'}}>
                                                        {/* Seat Category Selection - Only show if seats required */}
                                                        {isSeatsRequired === "Yes" && (
                                                            <div className="form-group mb-3 col">
                                                                <label>Seat Category:</label>
                                                                <select
                                                                    className="form-control"
                                                                    value={ticket.category_id}
                                                                    onChange={(e) =>
                                                                        handleTicketChange(dayIndex, ticketIndex, "category_id", e.target.value)
                                                                    }
                                                                    disabled={!isChecked || !selectedVenue}
                                                                >
                                                                    <option value="">Select Category</option>
                                                                    {seatCategories.map((category) => (
                                                                        <option key={category.value} value={category.value}>
                                                                            {category.label} ({category.total_seats} seats)
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        )}
                                                        
                                                        <div className="form-group mb-3 col">
                                                            <label>Ticket Type:</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Type"
                                                                value={ticket.type}
                                                                onChange={(e) =>
                                                                    handleTicketChange(dayIndex, ticketIndex, "type", e.target.value)
                                                                }
                                                                disabled={!isChecked}
                                                                readOnly={isSeatsRequired === "Yes"}
                                                            />
                                                        </div>

                                                        {/* Add Status field for each ticket type */}
                                                        <div className="form-group mb-3 col">
                                                            <label>Status:</label>
                                                            <select
                                                            className="form-control"
                                                            value={ticket.status || 'active'}
                                                            onChange={(e) =>
                                                                handleTicketChange(dayIndex, ticketIndex, "status", e.target.value)
                                                            }
                                                            disabled={!isChecked}
                                                            >
                                                            <option value="active">Active</option>
                                                            <option value="sold out">Sold Out</option>
                                                            <option value="coming soon">Coming Soon</option>
                                                            </select>
                                                        </div>

                                                        <div className="form-group mb-3 col">
                                                            <label>Time:</label>
                                                            <Select
                                                                options={timeOptions}
                                                                value={timeOptions.find(opt => opt.value === ticket.time) || null}
                                                                onChange={option => handleTicketChange(dayIndex, ticketIndex, "time", option ? option.value : "")}
                                                                isDisabled={!isChecked}
                                                                placeholder="Select Time"
                                                                isSearchable={false}
                                                            />
                                                        </div>
                                                        <div className="form-group mb-3 col">
                                                            <label>Total Tickets:</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Total"
                                                                value={ticket.total_tickets}
                                                                onChange={(e) =>
                                                                    handleTicketChange(
                                                                        dayIndex,
                                                                        ticketIndex,
                                                                        "total_tickets",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                min={ticket.assigned_tickets}
                                                                disabled={!isChecked}
                                                            />
                                                            {validation1.errors.tickets?.[dayIndex]?.tickets?.[ticketIndex]?.total_tickets &&
                                                            validation1.touched.tickets?.[dayIndex]?.tickets?.[ticketIndex]?.total_tickets && (
                                                                <small className="text-danger">
                                                                {validation1.errors.tickets[dayIndex].tickets[ticketIndex].total_tickets}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="form-group mb-3 col">
                                                            <label>Price:</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Price"
                                                                value={ticket.price}
                                                                onChange={(e) =>
                                                                    handleTicketChange(dayIndex, ticketIndex, "price", e.target.value)
                                                                }
                                                                min="1"
                                                                disabled={!isChecked}
                                                            />
                                                        </div>
                                                        <div className="form-group mb-3 col">
                                                            <label>Resell Min Price:</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Min"
                                                                value={ticket.resell_min_price}
                                                                onChange={(e) =>
                                                                    handleTicketChange(
                                                                        dayIndex,
                                                                        ticketIndex,
                                                                        "resell_min_price",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                min="1"
                                                                disabled={!isChecked}
                                                            />
                                                        </div>
                                                        <div className="form-group mb-3 col">
                                                            <label>Resell Max Price:</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Max"
                                                                value={ticket.resell_max_price}
                                                                onChange={(e) =>
                                                                    handleTicketChange(
                                                                        dayIndex,
                                                                        ticketIndex,
                                                                        "resell_max_price",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                min="1"
                                                                disabled={!isChecked}
                                                            />
                                                        </div>
                                                        <div className="form-group mb-3 col">
                                                        <label className="text-danger">Remaining Tickets:</label>
                                                        <input
                                                            type="number"
                                                            className="form-control disabled-input"
                                                            placeholder="Max"
                                                            value={ticket.total_tickets - ticket.assigned_tickets}
                                                            disabled
                                                        />
                                                        </div>

                                                        {ticketIndex > 0 && (
                                                            <div className="col-md-1 d-flex align-items-center">
                                                                <button
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() => deleteTicketRow(dayIndex, ticket.id)}
                                                                    type="button"
                                                                    disabled={!isChecked}
                                                                >
                                                                    <i className="fa-solid fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}

                                                <div className="row" style={{marginTop: '10px'}}>
                                                    <div className="col-12">
                                                        <button
                                                            className="btn btn-primary btn-sm"
                                                            onClick={(e) => addTicketRow(dayIndex, e)}
                                                            disabled={!isChecked}
                                                            type="button"
                                                        >
                                                            Add Ticket Type for {eventDuration === 1 ? 'Event' : `Day ${dayData.day}`}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="events-types-box">
                                        <div className="row">
                                            <p className="title-pass-price">
                                                10 Day Pass Ticket Price
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={isTenDayChecked}
                                                    onChange={handleTenDayCheckboxChange}
                                                />
                                            </p>
                                        </div>

                                        {isTenDayChecked && (
                                            <div className="day-tickets-section" style={{marginBottom: '30px', border: '1px solid #ddd', padding: '15px', borderRadius: '5px'}}>
                                                <div className="row" style={{marginBottom: '15px', alignItems: 'center'}}>
                                                    <div className="col-md-12">
                                                        <h5 className="day-title" style={{margin: '0', color: '#333', borderBottom: '2px solid #007bff', paddingBottom: '5px', display: 'inline-block'}}>
                                                            10 Day Pass Tickets
                                                        </h5>
                                                    </div>
                                                </div>

                                                {tenDayTickets.map((ticket, index) => (
                                                    <div className="row cstm-price-box" key={ticket.id} style={{marginBottom: '10px'}}>
                                                        {/* Seat Category Selection - Only show if seats required */}
                                                        {isSeatsRequired === "Yes" && (
                                                            <div className="form-group mb-3 col">
                                                                <label>Seat Category:</label>
                                                                <select
                                                                    className="form-control"
                                                                    value={ticket.category_id}
                                                                    onChange={(e) =>
                                                                        handleTenDayTicketChange(index, "category_id", e.target.value)
                                                                    }
                                                                    disabled={!isTenDayChecked || !selectedVenue}
                                                                >
                                                                    <option value="">Select Category</option>
                                                                    {seatCategories.map((category) => (
                                                                        <option key={category.value} value={category.value}>
                                                                            {category.label} ({category.total_seats} seats)
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        )}

                                                        <div className="form-group mb-3 col">
                                                            <label>Ticket Type:</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Type"
                                                                value={ticket.type}
                                                                onChange={(e) =>
                                                                    handleTenDayTicketChange(index, "type", e.target.value)
                                                                }
                                                                disabled={!isTenDayChecked}
                                                                readOnly={isSeatsRequired === "Yes"}
                                                            />
                                                        </div>

                                                        {/* Add Status field for each 10-day ticket type */}
                                                        <div className="form-group mb-3 col">
                                                            <label>Status:</label>
                                                            <select
                                                            className="form-control"
                                                            value={ticket.status || 'active'}
                                                            onChange={(e) =>
                                                                handleTenDayTicketChange(index, "status", e.target.value)
                                                            }
                                                            disabled={!isTenDayChecked}
                                                            >
                                                            <option value="active">Active</option>
                                                            <option value="sold out">Sold Out</option>
                                                            <option value="coming soon">Coming Soon</option>
                                                            </select>
                                                        </div>

                                                            <div className="form-group mb-3 col">
                                                                <label>Time:</label>
                                                                <Select
                                                                    options={timeOptions}
                                                                    value={timeOptions.find(opt => opt.value === ticket.time) || null}
                                                                    onChange={option => handleTenDayTicketChange(index, "time", option ? option.value : "")}
                                                                    isDisabled={!isTenDayChecked}
                                                                    placeholder="Select Time"
                                                                    isSearchable={false}
                                                                />
                                                            </div>

                                                        <div className="form-group mb-3 col">
                                                            <label>Total Tickets:</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Total"
                                                                value={ticket.total_tickets}
                                                                onChange={(e) =>
                                                                    handleTenDayTicketChange(
                                                                        index,
                                                                        "total_tickets",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                min={ticket.assigned_tickets}
                                                                disabled={!isTenDayChecked}
                                                            />
                                                            {validation1.errors.tenDayTickets?.[index]?.total_tickets &&
                                                                validation1.touched.tenDayTickets?.[index]
                                                                    ?.total_tickets && (
                                                                    <small className="text-danger">
                                                                    {validation1.errors.tenDayTickets[index].total_tickets}
                                                                    </small>
                                                                )}
                                                        </div>

                                                        <div className="form-group mb-3 col">
                                                            <label>Price:</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Price"
                                                                value={ticket.price}
                                                                onChange={(e) =>
                                                                    handleTenDayTicketChange(index, "price", e.target.value)
                                                                }
                                                                disabled={!isTenDayChecked}
                                                            />
                                                        </div>

                                                        <div className="form-group mb-3 col">
                                                            <label>Resell Min Price:</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Min"
                                                                value={ticket.resell_min_price}
                                                                onChange={(e) =>
                                                                    handleTenDayTicketChange(
                                                                        index,
                                                                        "resell_min_price",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                disabled={!isTenDayChecked}
                                                                min="1"
                                                            />
                                                        </div>

                                                        <div className="form-group mb-3 col">
                                                            <label>Resell Max Price:</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Max"
                                                                value={ticket.resell_max_price}
                                                                onChange={(e) =>
                                                                    handleTenDayTicketChange(
                                                                        index,
                                                                        "resell_max_price",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                disabled={!isTenDayChecked}
                                                                min="1"
                                                            />
                                                        </div>

                                                        <div className="form-group mb-3 col">
                                                        <label className="text-danger">Remaining Tickets:</label>
                                                        <input
                                                            type="number"
                                                            className="form-control disabled-input"
                                                            placeholder="Max"
                                                            value={ticket.total_tickets - ticket.assigned_tickets}
                                                            disabled
                                                        />
                                                        </div>

                                                        {index > 0 && (
                                                            <div className="col-md-1 d-flex align-items-center">
                                                                <button
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() => deleteTenDayTicketRow(ticket.id)}
                                                                    type="button"
                                                                    disabled={!isTenDayChecked}
                                                                >
                                                                    <i className="fa-solid fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}

                                                <div className="row" style={{marginTop: '10px'}}>
                                                    <div className="col-12">
                                                        <button
                                                            className="btn btn-primary btn-sm"
                                                            id="submit3"
                                                            onClick={addTenDayTicketRow}
                                                            disabled={!isTenDayChecked}
                                                        >
                                                            Add New Ticket Type
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                <div className="form-group mb-3 col-md-6 col-xs-12">
                                    <label className="form-label fw-bold mb-2">Additional Charges :</label>
                                    <div className="d-flex align-items-center gap-4">
                                    <p className="title-pass-price mb-0">
                                        <input
                                        className="form-check-input me-2"
                                        type="checkbox"
                                        checked={isCheckedGst}
                                        onChange={handleCheckGstChange}
                                        />
                                        GST
                                    </p>

                                    <p className="title-pass-price mb-0">
                                        <input
                                        className="form-check-input me-2"
                                        type="checkbox"
                                        checked={isCheckedTcs}
                                        onChange={handleCheckTcsChange}
                                        />
                                        TCS
                                    </p>
                                    </div>
                                </div>
                                </div>

                                <Link to="/events-list"
                                    type="submit"
                                    className="btn btn-primary me-2"
                                    id="submit1"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        validation1.handleSubmit();
                                        return false;
                                    }}>
                                    {'Update Event'}
                                </Link>
                                <Link to="/events-list" type="submit" className="btn btn-light">Cancel</Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default EditEvent;